/* ============================================================
   URINKING · Zusatz und Geschenk im Warenkorb mit einem Klick
   [01.10.2026, 02.10.2026 erweitert]
   Gehoert zu snippets/uk-korb-zusatz.liquid und uk-korb-geschenk.liquid.

   Ein Klick-Abfaenger fuer das ganze Dokument, nicht am Knopf: Die
   Schublade wird nach jeder Aenderung per innerHTML neu gebaut, ein
   Listener am Knopf ginge dabei jedes Mal verloren.

   Der Rueckweg ist DAWNS: /cart/add.js mit sections, danach
   cart-drawer.renderContents() - dieselbe Funktion, die auch der
   normale Kaufknopf benutzt. Kein zweiter Warenkorbweg.

   [02.10.2026] AUF DER WARENKORBSEITE gibt es keine Schublade (sie
   wird dort bewusst nicht geladen). Dort laedt die Seite nach dem
   Hinzufuegen neu - Zeilen, Summe und Geschenkauswahl stimmen dann
   sicher zusammen.
   ============================================================ */
(function () {
  /* Zweimal geladen (Schublade und Warenkorbseite), haette jeder Klick
     zwei Anfragen ausgeloest - also zwei Geschenke. */
  if (window.ukKorbZusatz) { return; }
  window.ukKorbZusatz = true;

  function weg(pfad) {
    var r = window.routes || {};
    return (r[pfad] || '/' + pfad.replace('_url', '').replace('_', '/')) + '.js';
  }

  /* Alle Geschenk- und Zusatzknoepfe gleichzeitig sperren: Wer schnell
     Geschenk A und dann B antippte, bekam vorher beide - und sofort
     die Warnung "Zu viele Geschenke". */
  function sperren(an) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-uk-zusatz], [data-uk-weg]'), function (k) {
      k.disabled = an;
    });
  }

  /* Abgelehnt (meist: nicht mehr vorraetig) - vorher ging der Knopf
     still wieder an, und niemand wusste, warum nichts passiert war. */
  function meldung(knopf, text) {
    var kasten = knopf.closest('.uk-geschenk, .uk-korb-zusatz') || knopf.parentNode;
    var alt = kasten.querySelector('.uk-korb-meldung');
    if (alt) { alt.remove(); }
    var p = document.createElement('p');
    p.className = 'uk-korb-meldung';
    p.setAttribute('role', 'alert');
    p.textContent = text || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
    kasten.appendChild(p);
  }

  function senden(knopf, pfad, nutzlast) {
    var schublade = document.querySelector('cart-drawer');
    var mitSchublade = schublade && typeof schublade.renderContents === 'function';
    if (mitSchublade) {
      nutzlast.sections = 'cart-drawer,cart-icon-bubble';
      nutzlast.sections_url = window.location.pathname;
    }
    sperren(true);
    knopf.classList.add('ist-am-laden');

    fetch(weg(pfad), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(nutzlast)
    })
      .then(function (r) { return r.json(); })
      .then(function (antwort) {
        if (antwort.status || antwort.errors) { throw antwort; }
        if (!mitSchublade) { window.location.reload(); return; }
        if (!antwort.sections) { throw antwort; }
        if (nutzlast.items) { antwort.id = nutzlast.items[0].id; }
        schublade.renderContents(antwort);
      })
      .catch(function (fehler) {
        sperren(false);
        knopf.classList.remove('ist-am-laden');
        meldung(knopf, fehler && (fehler.description || (typeof fehler.errors === 'string' ? fehler.errors : '')));
      });
  }

  document.addEventListener('click', function (e) {
    /* Entfernen-Knopf der Geschenkwarnung: nimmt nur den Ueberschuss
       heraus (data-uk-weg-menge = was in der Zeile bleiben darf). */
    var raus = e.target.closest('[data-uk-weg]');
    if (raus) {
      senden(raus, 'cart_change_url', {
        id: raus.getAttribute('data-uk-weg'),
        quantity: parseInt(raus.getAttribute('data-uk-weg-menge'), 10) || 0
      });
      return;
    }

    var knopf = e.target.closest('[data-uk-zusatz]');
    if (knopf) {
      senden(knopf, 'cart_add_url', {
        items: [{ id: parseInt(knopf.getAttribute('data-uk-zusatz'), 10), quantity: 1 }]
      });
    }
  });
})();
